if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      if (!('IntersectionObserver' in window)) {
        this.performRecommendations();
        return;
      }
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      const reducedPrefetch = connection?.saveData || ['slow-2g', '2g'].includes(connection?.effectiveType);
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.performRecommendations();
      }, { rootMargin: reducedPrefetch ? '350px 0px' : '1000px 0px' });
      this.observer.observe(this.parentElement);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) return;
      if (this.requested) return;
      this.requested = true;
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;
          if (!recommendationsHTML) return;
          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
          }
          recommendations.innerHTML = recommendationsHTML;
          this.initSlider();

          // initiate quick cart after fetch
          // to activate trigger button events
          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            } else {
              // if quick-cart-drawer does not exists, remove trigger buttons
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              })
            }
          }, 500);

        }).catch(() => { this.requested = false; });
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}

